window.initProductCardSliders = function () {
  const cards = document.querySelectorAll(
    ".product-card:not([data-slider-ready]):not([data-disable-slider])"
  );

  cards.forEach((card) => {
    const images = card.querySelectorAll(".product-card__image");
    if (!images.length) return;

    card.dataset.sliderReady = "true";

    let currentIndex = 0;
    let startX = 0;
    let startY = 0;
    let deltaX = 0;
    let isDragging = false;
    let hasMoved = false;
    let pointerId = null;
    let linkElement = null;

    /* -----------------------------
       Render base
    ------------------------------ */
    const showImage = (index) => {
      images.forEach((img, i) => {
        img.style.transition = "opacity 0.3s ease, transform 0.3s ease";
        img.style.opacity = i === index ? "1" : "0";
        img.style.transform = "translateX(0)";
        img.style.zIndex = i === index ? "2" : "1";
      });
    };

    /* -----------------------------
       POINTER DOWN
    ------------------------------ */
    const onPointerDown = (e) => {
      if (
        e.target.closest(".product-card__quick-add") ||
        e.target.closest(".product-card__nav") ||
        e.target.closest(".color-swatch")
      ) return;

      // Obtener el enlace del card
      linkElement = card.querySelector(".product-card__link");
      
      isDragging = true;
      hasMoved = false;
      pointerId = e.pointerId;
      startX = e.clientX;
      startY = e.clientY;
      deltaX = 0;

      // NO capturar el pointer inmediatamente - solo si hay movimiento
      // Esto permite que los clics funcionen normalmente

      images.forEach((img) => (img.style.transition = "none"));
    };

    /* -----------------------------
       POINTER MOVE
    ------------------------------ */
    const onPointerMove = (e) => {
      if (!isDragging || e.pointerId !== pointerId) return;

      const deltaY = Math.abs(e.clientY - startY);
      const width = card.offsetWidth;
      deltaX = e.clientX - startX;

      // Si hay movimiento significativo (más de 5px), considerar que es un drag
      if (Math.abs(deltaX) > 5 || deltaY > 5) {
        if (!hasMoved) {
          // Primera vez que detectamos movimiento - capturar el pointer ahora
          hasMoved = true;
          card.setPointerCapture(pointerId);
          // Solo deshabilitar el enlace si hay movimiento (drag real)
          if (linkElement) {
            linkElement.style.pointerEvents = "none";
          }
        }
        e.preventDefault();
      }

      // Si no ha habido movimiento, no hacer nada - permitir que el clic funcione
      if (!hasMoved) {
        return;
      }

      // Evitar interferencia con scroll vertical
      if (deltaY > Math.abs(deltaX)) {
        return;
      }

      // 🔒 Limitar al ancho del card
      deltaX = Math.max(-width, Math.min(width, deltaX));

      const direction = deltaX < 0 ? 1 : -1;
      const nextIndex = currentIndex + direction;

      images.forEach((img, i) => {
        if (i === currentIndex) {
          img.style.opacity = "1";
          img.style.transform = `translateX(${deltaX}px)`;
        } else if (i === nextIndex && images[nextIndex]) {
          img.style.opacity = "1";
          img.style.zIndex = "3";
          img.style.transform = `translateX(${direction * width + deltaX}px)`;
        } else {
          img.style.opacity = "0";
        }
      });
    };

    /* -----------------------------
       POINTER UP / CANCEL
    ------------------------------ */
    const endPointerDrag = (e) => {
      if (!isDragging || e.pointerId !== pointerId) return;

      const hadMovement = hasMoved;
      
      isDragging = false;
      
      // Solo liberar el pointer si lo capturamos
      if (hadMovement) {
        try {
          card.releasePointerCapture(pointerId);
        } catch (e) {
          // Ignorar errores si el pointer ya fue liberado
        }
      }
      
      pointerId = null;

      // Restaurar pointer-events del enlace
      if (linkElement) {
        linkElement.style.pointerEvents = "";
      }

      const width = card.offsetWidth;
      let newIndex = currentIndex;

      // Solo cambiar imagen si hubo movimiento significativo (drag real)
      if (hadMovement && Math.abs(deltaX) > width * 0.35) {
        if (deltaX < 0 && currentIndex < images.length - 1) {
          newIndex++;
        }
        if (deltaX > 0 && currentIndex > 0) {
          newIndex--;
        }
        currentIndex = newIndex;
        showImage(currentIndex);
      } else if (hadMovement) {
        // Si hubo movimiento pero no suficiente, volver a la imagen actual
        showImage(currentIndex);
      } else {
        // Si no hubo movimiento, fue un clic - NO hacer nada aquí
        // El enlace manejará el clic normalmente sin interferencia
      }
      
      hasMoved = false;
      deltaX = 0;
    };

    card.addEventListener("pointerdown", onPointerDown);
    card.addEventListener("pointermove", onPointerMove);
    card.addEventListener("pointerup", endPointerDrag);
    card.addEventListener("pointercancel", endPointerDrag);
    card.addEventListener("pointerleave", endPointerDrag);

    /* -----------------------------
       FLECHAS
    ------------------------------ */
    const prev = card.querySelector(".product-card__nav--prev");
    const next = card.querySelector(".product-card__nav--next");

    if (prev) {
      prev.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (currentIndex > 0) {
          currentIndex--;
          showImage(currentIndex);
        }
      });
    }

    if (next) {
      next.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (currentIndex < images.length - 1) {
          currentIndex++;
          showImage(currentIndex);
        }
      });
    }

    /* -----------------------------
       INIT
    ------------------------------ */
    showImage(currentIndex);
  });
};

document.addEventListener("DOMContentLoaded", () => {
  window.initProductCardSliders();
});
